import { PropsWithChildren, useEffect } from 'react';
import FeedbackDrawer from 'views/Management/Feedback/components/FeedbackDrawer';
import useModal from 'hooks/useModal';
import useCaseCategory from 'views/Management/Feedback/hooks/useCaseCategory';
import { eventBus } from 'services/eventBus';

interface FeedbackProviderProps {}

export const FeedbackProvider = (props: PropsWithChildren<FeedbackProviderProps>) => {
  const { children } = props;
  const { visible, show, hide, meta: caseId } = useModal<Feedback.CaseBasicInfo['caseId']>();
  const { categoryMap } = useCaseCategory(visible);

  useEffect(() => {
    const handler = (meta?: Feedback.CaseBasicInfo['caseId']) => {
      show(meta);
    };

    eventBus.on('SHOW_FEEDBACK_MODAL', handler);
    return () => {
      eventBus.off('SHOW_FEEDBACK_MODAL', handler);
    };
  }, [show]);

  return (
    <>
      {caseId && (
        <FeedbackDrawer
          visible={visible}
          onClose={() => hide()}
          caseId={caseId}
          categoryMap={categoryMap}
          onCaseUpdated={() => {
            eventBus.emit('CASE_UPDATED');
          }}
        />
      )}
      {children}
    </>
  );
};
